import { viewport } from '../../utils/viewport';
import { loadChartScript } from '../../utils/scripts';

document.addEventListener('alpine:init', () => {
  Alpine.data('countryStat', () => ({
    format(value, suffix) {
      if (value > 9999) {
        value = value.toLocaleString('en', { useGrouping: true });
      }

      return value + suffix;
    },
  }));

  Alpine.data('countryStatCard', () => ({
    async init() {
      this.$nextTick(() => {
        loadChartScript().then(() => {
          new CountryStatCardChart(this.$refs.chart);
        });
      });
    },
  }));

  Alpine.data('pmCountries', () => ({
    list: [],
    allVisible: false,
    rest: 0,

    init() {
      const a = [...this.$root.querySelectorAll('[data-item]')];
      const max = this.calcMax(a);

      this.rest = a.length - max;

      a.forEach((a, i) => {
        this.list.push({ html: a.outerHTML, visible: i <= max });
        a.remove();
      });
    },

    calcMax(elements) {
      let usedCharacters = 0;

      return elements.reduce((max, element) => {
        usedCharacters += element.textContent.length;

        if (usedCharacters <= 50) {
          max++;
        }

        return max;
      }, 0);
    },
  }));
});

class CountryStatCardChart {
  constructor(el) {
    this.el = el;
    this.canvas = el.querySelector('.ecommerce-text-lists__charts-percent-canvas');
    this.ctx = this.canvas.getContext('2d');
    this.percent = +this.canvas.dataset.percent.replace('%', '');
    this.data = [
      { label: '', value: this.percent },
      { label: '', value: 100 - this.percent },
    ];
    this.palette = ['rgb(38, 116, 224)', 'rgb(230, 230, 230)'];

    viewport.observe(this.el, () => {
      if (!this.chart) {
        this.chart = new Chart(this.ctx, this.getOptions());
      }
    });
  }

  getOptions() {
    return {
      type: 'doughnut',
      data: {
        labels: this.data.map((item) => item.label),
        datasets: [
          {
            data: this.data.map((item) => item.value),
            backgroundColor: this.palette,
            hoverBackgroundColor: this.palette,
          },
        ],
      },
      options: {
        datasets: {
          doughnut: {
            cutout: '56%',
            hoverBorderWidth: 0,
            hoverOffset: 0,
            offset: 0,
            borderRadius: 6,
          },
        },
        animation: {
          animateScale: true,
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    };
  }
}